// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease;
}

.modal-content {
  background: #1a1a2e;
  border: 1px solid #00f5ff;
  border-radius: 16px;
  padding: 2rem;
  width: 90%;
  height: 90vh;
  max-width: 1200px;
  box-shadow: 0 0 30px rgba(0, 245, 255, 0.4);
  animation: slideIn 0.4s ease-out;
  position: relative;
  color: #fff;
  font-family: 'Share Tech Mono', monospace;
  display: flex;
  flex-direction: column;
}

.modal-close-button {
  position: absolute;
  top: 15px;
  right: 20px;
  background: none;
  border: none;
  color: #fff;
  font-size: 2rem;
  cursor: pointer;
  line-height: 1;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(0, 245, 255, 0.3);
  padding-bottom: 1rem;
  margin-bottom: 1.5rem;
}

.modal-header h2 {
  margin: 0;
  color: #00f5ff;
  text-shadow: 0 0 5px #00f5ff;
}

.modal-body {
  display: flex;
  gap: 2rem;
  flex-grow: 1;
  overflow: hidden;
}

.device-info {
  flex: 1 1;
  padding-right: 1.5rem;
  border-right: 1px solid rgba(255, 0, 255, 0.3);
}

.device-info h4 {
  color: #ff00ff;
  margin-bottom: 1.5rem;
}

.device-info p {
  margin: 1rem 0;
  word-wrap: break-word;
}

.device-info p strong {
  color: #00f5ff;
  display: block;
  margin-bottom: 0.25rem;
}

.modal-chart-container {
  flex: 2 1;
  height: auto;
  min-height: 250px;
}

.modal-actions {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(0, 245, 255, 0.3);
  text-align: center;
}

.modal-actions h4 {
  color: #39ff14;
  margin-bottom: 1rem;
}

.modal-actions button {
  background-color: transparent;
  border: 1px solid #ff00ff;
  color: #ff00ff;
  padding: 10px 20px;
  margin: 0 10px;
  border-radius: 5px;
  cursor: pointer;
  font-family: 'Share Tech Mono', monospace;
  transition: background-color 0.2s, color 0.2s;
}

.modal-actions button:hover {
  background-color: #ff00ff;
  color: #1a1a2e;
}

@keyframes slideIn {
  from { transform: translateY(-50px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/DeviceDetailModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,2CAA2C;EAC3C,gCAAgC;EAChC,kBAAkB;EAClB,WAAW;EACX,yCAAyC;EACzC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,+CAA+C;EAC/C,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  animation: fadeIn 0.3s ease;\n}\n\n.modal-content {\n  background: #1a1a2e;\n  border: 1px solid #00f5ff;\n  border-radius: 16px;\n  padding: 2rem;\n  width: 90%;\n  height: 90vh;\n  max-width: 1200px;\n  box-shadow: 0 0 30px rgba(0, 245, 255, 0.4);\n  animation: slideIn 0.4s ease-out;\n  position: relative;\n  color: #fff;\n  font-family: 'Share Tech Mono', monospace;\n  display: flex;\n  flex-direction: column;\n}\n\n.modal-close-button {\n  position: absolute;\n  top: 15px;\n  right: 20px;\n  background: none;\n  border: none;\n  color: #fff;\n  font-size: 2rem;\n  cursor: pointer;\n  line-height: 1;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid rgba(0, 245, 255, 0.3);\n  padding-bottom: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.modal-header h2 {\n  margin: 0;\n  color: #00f5ff;\n  text-shadow: 0 0 5px #00f5ff;\n}\n\n.modal-body {\n  display: flex;\n  gap: 2rem;\n  flex-grow: 1;\n  overflow: hidden;\n}\n\n.device-info {\n  flex: 1;\n  padding-right: 1.5rem;\n  border-right: 1px solid rgba(255, 0, 255, 0.3);\n}\n\n.device-info h4 {\n  color: #ff00ff;\n  margin-bottom: 1.5rem;\n}\n\n.device-info p {\n  margin: 1rem 0;\n  word-wrap: break-word;\n}\n\n.device-info p strong {\n  color: #00f5ff;\n  display: block;\n  margin-bottom: 0.25rem;\n}\n\n.modal-chart-container {\n  flex: 2;\n  height: auto;\n  min-height: 250px;\n}\n\n.modal-actions {\n  margin-top: 2rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid rgba(0, 245, 255, 0.3);\n  text-align: center;\n}\n\n.modal-actions h4 {\n  color: #39ff14;\n  margin-bottom: 1rem;\n}\n\n.modal-actions button {\n  background-color: transparent;\n  border: 1px solid #ff00ff;\n  color: #ff00ff;\n  padding: 10px 20px;\n  margin: 0 10px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-family: 'Share Tech Mono', monospace;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.modal-actions button:hover {\n  background-color: #ff00ff;\n  color: #1a1a2e;\n}\n\n@keyframes slideIn {\n  from { transform: translateY(-50px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
